<template>
  <div class="container-md">
    <h1 class="page-header">Assemblies</h1>

    <DbTableControl :buttons="buttons">
    </DbTableControl>

    <div class="row mt-5 mb-5">
      <div class="col-lg-4 col-md-6 mt-4" v-for="i in items" :key="i.id">
        <router-link class="btn btn-secondary btn-lg btn-block" :to="'/assembly/' + i.id">{{
          i.name
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { createWhereTextSearch } from "../lib/sql.js";
import { authFetch } from "../lib/auth.js";
import dbTableMixin from "../lib/dbtable-mixin";
import DbTableControl from "../components/DbTableControl";

export default {
  mixins: [dbTableMixin],
  components: {
    DbTableControl,
  },
  data() {
    return {
      buttons: [
        {
          to: "/assembly",
          text: "Add assembly",
          accesskey: "a",
          fa: "plus",
        },
      ],
      items: [],
    };
  },
  methods: {
    load() {
      let uri = "/db/assembly_view";
      if (this.searchtext) {
        uri +=
          "&where=" +
          encodeURIComponent(createWhereTextSearch(this.searchtext, ["name"]));
      }
      authFetch(uri)
        .then((resp) => resp.json())
        .then((data) => (this.items = data));
    },
  },
};
</script>